import { Component, OnInit } from '@angular/core';
import { IviMy23SharedService } from '../ivi-my23-shared.service';
import { Router } from '@angular/router';

@Component({
    selector: 'app-ivi-honda-view',
    templateUrl: './ivi-honda-view.component.html',
    styleUrls: ['./ivi-honda-view.component.scss'],
    standalone: false
})
export class IviHondaViewComponent implements OnInit {
  isRenew: boolean = false;
  url: string | null = null; 
  selectedLanguage: 'en' | 'fr' = 'en';
  country: string | undefined;
  subscriptionType: any;
  errorMessage: any;
  constructor(private iviDataService: IviMy23SharedService, private router: Router) { }

  ngOnInit(): void {
    this.country = this.iviDataService.countryCode; 
    this.isRenew = this.iviDataService.isRenewal();
    this.subscriptionType = this.iviDataService.subscriptionType;
    const payload ={
      "targetApp": " ",
      "vin": " "
    }
    if(this.subscriptionType === 'enroll'){
      this.iviDataService.getEnrollmentDeeplinkApi().subscribe({
        next:(response)=>{
          
          this.url = response?.Description?.deepLinkUrl;
        },
        error:(errorResponse)=>{
          
          this.errorMessage = errorResponse?.message || 'Unknown error';
          this.router.navigate(['ivi/my23/enrollmentApiError'])
        }
      })
    }else if(this.subscriptionType === 'renew'){
      this.iviDataService.getRenewalDeeplinkApi().subscribe({
        next:(response)=>{
          
          this.url = response?.Description?.deepLinkUrl;
        },
        error:(errorResponse)=>{
          
          this.errorMessage = errorResponse?.message || 'Unknown error';
          this.router.navigate(['/ivi/my23/renewalApiError'])
        }
      })
    }
  }
  showLanguageToggle = false;
  
  translations = {
    en: {
      activateText: 'Activate your remote services \n trial with HondaLink today.',
      subscribeText: 'Subscribe to keep using these \n HondaLink features.',
      scanMessage: {
       subscription: 'Scan the QR code to subscribe.',
       trial: 'Scan the QR code with your \n phone to get started.'},
      
      trialExpiringSoonMessage: 'Your remote services trial is expiring soon.',
      englishLanguageTitle: 'English',
      frenchLanguageTitle: 'French'
    },
    fr: {
      activateText: 'Activez votre essai des services \n à distance avec HondaLink dès \n aujourd\'hui.',
      subscribeText:'Abonnez-vous pour continuer \n à utiliser ces fonctions \n  HondaLink.',
      scanMessage: {
        subscription: 'Balayez le code QR pour vous abonner.',
        trial: 'Balayez le code QR avec votre \n téléphone pour commencer.'},
      trialExpiringSoonMessage:'Votre essai des services à distance expirera bientôt.',
      englishLanguageTitle: 'Anglais',
      frenchLanguageTitle: 'Français'
    },
  };
  displayedText = this.translations.en;
  
  onLanguageChange(event: any) {
    this.selectedLanguage = event.target.checked ? 'fr' : 'en';
    this.displayedText = this.translations[this.selectedLanguage];
    // Title change removed: IVI head unit only captures title on initial page load
    // Server-side middleware now handles title based on vehicleMake parameter
  }
}
